import { tabAccessControl } from "../../../_helpers/access-control";

let InshellTabs = [
    {
        text: "Current Lots",
        path: "/almondco-inshell",
        applicationFeatureCode: "Inshell"
    },
    {
        text: "Freight Labels",
        path: `/almondco-freight-labels`,
        applicationFeatureCode: "Inshell",
    }
]

function GetIndexByTabName(tabName) {
    return tabAccessControl(InshellTabs).findIndex((x) => x.text == tabName);
}

export { InshellTabs, GetIndexByTabName };